import React, { useEffect, useContext, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/Cart.scss';
import Header from './Header';
import Configuracion from './Configuracion/Configuracion';
import Resumen from './Resumen/Resumen';
import Footer from './Footer';
import TransferSearch from '../views/TransferSearch';
import DrawerBodyEmpty from './Header/DrawerCartSummary/DrawerBodyEmpty';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { clearGlobalDataAfterBuy, clearConfigData } from '../globalslice';
import Card from '@mui/material/Card';
import { useTranslation } from 'react-i18next';
import CartSteps from './CartSteps';
import CartListHeader from './CartListHeader';
import getFeedCart from '../services/FeedCart';
import EmailMktWrapper from './Configuracion/EmailMktWrapper';
import ProductGuard from './ProductGuard';

const Cart = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const searchParams = new URLSearchParams(window.location.search);
  const transfer = searchParams.has('transfer')
  const idproduct = searchParams.get('producto') || null;
  const ResumenData = useSelector(state => state.global.ResumenData);
  const idResumen = useSelector(state => state.global.idResumen);
  const currency = useSelector((state) => state.global.currency);
  const initialized = useRef(false)

  const countCartItems = ResumenData.filter((item) => item.actual === false).length;

  //Obtiene los items actualmente en configuracion que NO son transferencias
  const countCartConfig = ResumenData.filter(
    (item) => 
      item.actual === true && 
      Array.isArray(item.product.domain_section) && 
      item.product.domain_section.every(domain => domain.domain_type !== "transfer")
  ).length;

  const fetchFeedCart = async () => {
    try {
      console.log("Initializing")
      const data = await getFeedCart(ResumenData, dispatch, idResumen, currency);
    } catch (error) {
      console.error('Error al obtener los datos:', error);
    }
  };
  

  useEffect(() => {
    //Cuando no está configurando un producto en la url ?producto=n (si quiere ir a raíz /)
    if( !idproduct || idproduct == null) {
      //Si el usuario ya tiene productos en su carrito y no está transfiriendo un dominio lo manda al checkout
      if( !transfer) {
        if( countCartItems > 0) {
          navigate('/checkout')
        } else {
          //Si se quedó configurando y quiere ir a raíz, borra los productos
          dispatch(clearGlobalDataAfterBuy());
        }
      } else {
        //landing de transferencia de dominio
        if(countCartConfig) {
          dispatch(clearConfigData());
        }
      }
    }

    if (!initialized.current) {
      initialized.current = true
      fetchFeedCart()
    }

  });

 return (
  <ProductGuard idproduct={idproduct}>
    <div className="cart-contenido">
      <Header changeCart={true} showCartCount />
      <div className="row-cart">
        {
        transfer ? <TransferSearch /> :
        (!idproduct || idproduct == null ?  (
          //Carrito vacío
          <>
          <div className="col-md-7 col-sm-12 col-xs-12 cf-content">  
            <CartSteps numberStep={1} />
            <div style={{ fontSize: '2em', marginTop: 32 }}>{t("myCart.title")}</div>
            <Card variant="outlined">
              <CartListHeader />
              <DrawerBodyEmpty />
            </Card>
          </div>
          </>
          
        ) 
        :  <EmailMktWrapper idproduct={idproduct} />)
        }
        <Resumen />
      </div>
      <div className="cart-footer">
        <Footer />
      </div>
    </div>
    </ProductGuard>
  );
};

export default Cart;
